import { render, staticRenderFns } from "./SobreView.vue?vue&type=template&id=9dbb35d8&"
import script from "./SobreView.vue?vue&type=script&lang=js&"
export * from "./SobreView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports